import React, { useState } from 'react';
import { useEditMode } from '@/context/EditModeContext';
import { useCurrency } from '@/context/CurrencyContext';
import {
  Car,
  ChevronDown,
} from 'lucide-react';

const InfoRow = ({ label, value, isEditMode }) => (
  <div className="flex justify-between items-center py-2.5 border-b border-border last:border-b-0">
    <span className="text-sm text-muted-foreground">{label}</span>
    <span className={`text-sm font-medium text-right max-w-[60%] truncate ${isEditMode ? 'border border-dashed border-yellow-500 rounded px-2 py-0.5' : ''}`}>
      {value || 'N/A'}
    </span>
  </div>
);

export function VehicleDetailsSection({ data }) {
  const { isEditMode } = useEditMode();
  const { t } = useCurrency();
  const [isExpanded, setIsExpanded] = useState(false);

  const primaryInfo = [
    { label: t('sampleReport.make'), value: data.make },
    { label: t('sampleReport.model'), value: data.model },
    { label: t('sampleReport.year'), value: data.year },
    { label: t('sampleReport.fuel'), value: data.fuel },
    { label: t('sampleReport.transmissionLabel'), value: data.transmission },
  ];

  const secondaryInfo = [
    { label: t('sampleReport.mfgDate'), value: data.mfgDate },
    { label: t('sampleReport.regNumber'), value: data.regNo },
    { label: t('sampleReport.regDate'), value: data.regDate },
    { label: t('sampleReport.colour'), value: data.colour },
    { label: t('sampleReport.engineCC'), value: data.engineCC + ' cc' },
    { label: t('sampleReport.engineNo'), value: data.engineNo },
    { label: t('sampleReport.chassisNo'), value: data.chassisNo },
  ];

  return (
    <section className="px-4 md:px-0 mt-4 md:mt-6">
      <div className="mobile-card md:rounded-2xl">
        <button
          className="w-full mobile-card-header flex items-center justify-between"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="flex items-center gap-2">
            <div className="p-1.5 md:p-2 rounded-lg bg-accent/10">
              <Car className="h-4 w-4 md:h-5 md:w-5 text-accent" />
            </div>
            <h2 className="font-semibold font-display text-base md:text-lg">{t('sampleReport.vehicleDetails')}</h2>
          </div>
          <ChevronDown className={`h-5 w-5 text-muted-foreground transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
        </button>

        <div className="mobile-card-body pt-0">
          {/* Always visible primary info */}
          {primaryInfo.map((item, index) => (
            <InfoRow key={index} {...item} isEditMode={isEditMode} />
          ))}

          {/* Collapsible secondary info */}
          {isExpanded && secondaryInfo.map((item, index) => (
            <InfoRow key={`sec-${index}`} {...item} isEditMode={isEditMode} />
          ))}

          {!isExpanded && (
            <button
              className="w-full py-2 text-xs text-accent hover:text-accent/80 transition-colors"
              onClick={() => setIsExpanded(true)}
            >
              {t('sampleReport.showMore')}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default VehicleDetailsSection;
